import { createFileRoute } from '@tanstack/react-router';

import { LoginFlow } from 'src/components/auth/LoginFlow';

export const Route = createFileRoute('/(auth)/login')({
    component: LoginFlow,
});
